import { DecisionNode } from 'lib/types/models';

export type NodeType =
  | 'boolean'
  | 'amount'
  | 'numeric'
  | 'money'
  | 'percentage'
  | 'days'
  | 'string'
  | 'final'
  | 'date'
  | 'decisionEngine'
  | null;

export const NODE_TYPE_NAMES = {
  boolean: 'Si o no',
  amount: 'Monto',
  numeric: 'Número',
  money: 'Monto',
  percentage: 'Porcentaje',
  days: 'Días',
  string: 'Texto',
  final: 'Final',
  date: 'Fecha',
  decisionEngine: 'Motor de decisiones',
};

export type Range = {
  value?: string;
  nodeId?: number;
  decisionNodeId?: number;
  max?: string | null;
};

export type Node = {
  id: number;
  fatherNodeId: number | null;
  originNodeId: number | null;
  value: string;
  type: NodeType;
  ranges: Range[];
  operation: string;
  description: string;
  name: string;
  children?: Node[];
  metricId?: number | null;
};

export type EditNode = Node & {
  editingOperation?: string;
};

export const ENGINE_DESCRIPTIONS = {
  tree: 'Este motor te permite crear un árbol de decisiones el cual te ayudará a tomar decisiones de manera automática.',
  matrix:
    'Este motor te permite crear una matriz de decisiones el cual te ayudará a tomar decisiones de manera automática.',
};

export type EngineType = keyof typeof ENGINE_DESCRIPTIONS | null;

export const REVISION_OBJECTIVE_DESCRIPTIONS = {
  invoice: 'Revisión de facturas cuando se solicita factoring de facturas',
  creditLine: 'Revisión de líneas de crédito',
  'factoring-request': 'Revisión de solicitudes de factoring',
  'credit-request': 'Revisión de solicitudes de crédito',
  'creditLine-payers': 'Revisión de líneas de crédito - Deudores',
  'factoring-request-payers': 'Revisión de solicitudes de factoring - Deudores',
  'sgr-warranty-request': 'Revisión de solicitudes de garantía SGR',
  'confirming-request': 'Revisión de solicitudes de confirming',
};

export type RevisionObjective =
  | keyof typeof REVISION_OBJECTIVE_DESCRIPTIONS
  | null;

export type CategorizedNodes = {
  [key: string]: DecisionNode[];
};

export const NEW_NODE = {
  id: 0,
  sonIncorrectNodeId: null,
  sonCorrectNodeId: null,
  originNodeId: null,
  value: '',
  type: null,
  description: '',
  name: '',
  fatherNodeDecision: null,
  operation: '',
  fatherNodeId: null,
  ranges: [],
};
